
import React from 'react';
import {Card} from 'antd';
import styles from './styles';
import './styles.css';

import {UsergroupAddOutlined, ArrowRightOutlined } from '@ant-design/icons';

import img from '../../assets/Images/golden.jpg';

const Featurescard = (props) => {
    return(
        <>
        <Card
            bordered
            style={{margin: '0 20px', backgroundImage: `url(${props.bgImage})`, backgroundPosition: 'top', backgroundRepeat: 'no-repeat', 
                backgroundSize: 'cover',}}
            className="feadtured-card"
             >
            <div style={{}} className="cardBody">
               <div className="innerBody">
               <span style={styles.cardIcon} >{props.cardIcon}</span>
                <h1 style={styles.cardHead} id="cardHeading">{props.cardHeading}</h1>
                <span className="span"></span>
               </div>
               </div>
            <div style={{}} className="card-body">
            <div className="inner">
            <span style={styles.cardIcon} >{props.cardIcon}</span>
                <h1 style={styles.cardHead}>{props.cardHeading}</h1>
                <div style={styles.featuresPara}>
                    {props.cardPara}
                </div>
                <a href="#" style={styles.featuresLink}>Read More</a>
                </div>
            </div>
             </Card>
        </>
    )
}
export default Featurescard;